import React from 'react'
import { optimizationCatalog, OptimizationDefinition } from '@marketing-milk/interfaces'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

type Props = {
  campaignIndex: number
  readyToPublish?: boolean
  optimization: OptimizationDefinition
  setOptimization: (optimization: OptimizationDefinition) => void
}

export const SelectCampaignGoalField = (props: Props) => {
  const selected = props.optimization

  return (
    <FormControl>
      <InputLabel htmlFor={`campaign-${props.campaignIndex}-goal`}>Goal</InputLabel>
      <Select
        placeholder="Goal"
        labelId={`campaign-${props.campaignIndex}-goal`}
        variant="outlined"
        name={`campaign-${props.campaignIndex}-goal`}
        value={selected.key}
        inputProps={{
          label: 'Goal',
          id: `campaign-${props.campaignIndex}-goal`,
        }}
        onChange={({ target }) => {
          const chosen = optimizationCatalog.find(entry => entry.key === target.value)
          if (chosen) props.setOptimization(chosen)
        }}
        label={'Goal'}
        required={true}
      >
        {optimizationCatalog.map(entry => (
          <MenuItem key={entry.key} value={entry.key} style={{ width: '100%' }}>
            {entry.objectiveLabel} · {entry.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
